import {
  Button,
} from "@mui/material";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import styles from "./HeaderComponent.module.css";
import LeagueNameInput from "./LeagueNameInput";
import SportDropdown from "./SportDropdown";

const HeaderComponent = () => {
  const navigate = useNavigate();
  const [error, setError] = useState({ leagueName: '', sport: '' });

  // "Lift" the state up here so it can be shared
  const [leagueName, setLeagueName] = useState("");
  const [sport, setSport] = useState("");

  const handleButtonClick = () => {
    let hasError = false;
    // Ensure league name is not empty else show user an error
    if (!leagueName) {
      setError(prevError => ({ ...prevError, leagueName: 'League name is required' }));
      hasError = true;
    } else {
      setError(prevError => ({ ...prevError, leagueName: '' }));
    }
    // Ensure sport is selected else show user an error
    if (!sport) {
      setError(prevError => ({ ...prevError, sport: 'Sport is required' }));
      hasError = true;
    } else {
      setError(prevError => ({ ...prevError, sport: '' }));
    }

    if (hasError) {
      return;
    }

    navigate('../invitemembers', {
    state: {
    leagueName,
    sport
        }
      });
    };

    const handleCancelClick = () => {
      navigate('/commissionerdash');
    };

  return (
    <div className={styles.headerComponent}>
      <h3 className={styles.title}>What is your league’s name?</h3>
      <LeagueNameInput
        className={styles.leagueNameInput}
        value={leagueName}
        onChange={(e) => setLeagueName(e.target.value)}
      />
      {error.leagueName && <div className={styles.error}>{error.leagueName}</div>}
      <SportDropdown
        className={styles.leagueNameInput}
        value={sport}
        onChange={(e) => setSport(e.target.value)}
      />
      {error.sport && <div className={styles.error}>{error.sport}</div>}
      <div className={styles.buttonContainer}>
        <Button
          className={styles.buttonPrimary}
          disableElevation
          variant="contained"
          onClick={handleButtonClick}
        >
          Next
        </Button>
        <div className={styles.cancel} onClick={handleCancelClick}>Cancel</div>
      </div>
    </div>
  );
};

export default HeaderComponent;

